const debugMode = false;

const currentPermalink = document.querySelector('#current_perma_link');
const cpv = currentPermalink?.value;


function permalinkExists() {
  if (!currentPermalink) {
    return;
  }
}


// check the URLSearchParams for identifiers and return css-class
function urlParamsHas(base, identifier, prefix = '') {
  if (base.has(identifier)) {

    classname += prefix + "_" + base.get(identifier + ' ');

    return classname;
  }
}


function setAcceptanceSession(base, identifier) {

  if (base.get('cmd') && base.get('cmd') == 'getAcceptance') {

    // set sessionstorage
    sessionStorage['first-visit'] = 'true';

  } else {

    const isFirstVisit = sessionStorage['first-visit'];

    if (isFirstVisit === 'true') classname += ' is-first-visit';

    // reset first visit on home repository
    if (
      base.get('target') && base.get('target') === 'root_1'
      || cpv?.includes('root_1')
    ) {

      sessionStorage['first-visit'] = 'false';

    }

    return classname;
  }
}


// check for elements in currentPermalink for page type recognition
function checkCurrentPermalink(cssClass, element1ToCheck, element2ToCheck = '') {
  if (currentPermalink &&
    currentPermalink.value.includes(element1ToCheck) ||
    currentPermalink.value.includes(element2ToCheck)
  ) {
  classname += " " + cssClass;
  return classname;
  }
}


function hideObjectOnCondition(categoryId, objectName) {
  const elementToHide = document.querySelector(objectName);
  if (
    elementToHide
    && currentPermalink
    && currentPermalink.value.includes(categoryId)
  )
  {
    elementToHide.classList.add('js-hide');
  }
}


// check if user is logged in
function isLoggedIn() {
  const avatar = document.querySelector('.il-avatar');
  if (!avatar) {
    classname += " not-logged-in";
  } else {
    classname += " logged-in";
  }
  return classname;
}


// check for object only visible for admin and mika-trainer rolle
function checkForObjectAndAddClass(objectId, clName, categoryToCheck) {

  // add category(es) to check in
  if (cpv && cpv.indexOf(categoryToCheck) > -1) {
    // we are in the right category

    // get all object blocks
    const blocksInPage = [...document.querySelectorAll('.ilContainerBlock')];

    blocksInPage.forEach(block => {
      const blockData = block.getAttribute('data-store-url');
      if (blockData && blockData.indexOf(objectId) > -1) {
        debugMode && console.log('add ' + clName);
        classname += ` ${clName}`;
      } else {
        debugMode && console.log(`${objectId} not found`);
      }
    });
  }
  return classname
}


//add role name class to il layout page content
//new CSS rules can be then created to display/hide content according to the user's global role
function getRolleCookie() {

  const ilLayoutPageContentClass = document.getElementsByClassName('il-layout-page').item(0);
  let roleClassName = 'check';
  const cookieName = "loggedRoleName";

  //in case there are special characters
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(';');

  for(let i = 0; i <cookieArray.length; i++) {
    let singleCookie = cookieArray[i];
    while (singleCookie.charAt(0) == ' ') {
      singleCookie = singleCookie.substring(1);
    }
    if (singleCookie.indexOf(cookieName) == 0) {
      roleClassName = singleCookie.substring(cookieName.length, singleCookie.length);
    }
  }

  if (roleClassName.charAt(0) == '=') {
    roleClassName = roleClassName.substring(1).toLowerCase().replace(/\//g, '');
  }

  classname += ` role-${roleClassName}`;

  return classname
}





function hideHeaderOnCondition(identifier) {

  permalinkExists();

  const header = document.querySelector('.media.il_HeaderInner');

  if (cpv && cpv.includes(identifier) && header) {
    header.classList.add('js-hide');
  }
}

function hideBreadcrumbsInStartpage() {

  permalinkExists();

  const breadcrumbs = document.querySelector('.crumb');

  if (cpv && cpv.includes('_root_1') && breadcrumbs) {
    breadcrumbs.classList.add('js-hide');
  }
}

//add class to hide early and late hours cells of booking object table with css
function addClassBookingTable() {

  const bookingTable = document.getElementsByTagName("table")[0];
  if (bookingTable) {
    const morningHoursBookingTable = bookingTable.rows[1].cells[0];
    const eveningHoursBookingTable = bookingTable.rows[bookingTable.rows.length-1].cells[0];

    if (window.location.href.indexOf("ilbookingprocessgui") > -1 && bookingTable) {
      morningHoursBookingTable.classList.add("hidden_booking_hours");
      eveningHoursBookingTable.classList.add("hidden_booking_hours");
    }
  }
}

function detectAdminPage() {
  const URLParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(new URLSearchParams(location.search));

  if (paramsObject) {
    if (URLParams.has('baseClass')) {
      const noSidebarParams = ['ilAdministrationGUI'];

      if (noSidebarParams.indexOf(paramsObject.baseClass) > -1) {
        classname += ' admin-page';
      }
      return classname;
    }
  }
}


// check for ilTab menu
// if no settings tab the user is not admin
// then hide
function hideInfoMenu() {

  const objectInfoMenu = document.querySelector('ul#ilTab');

  const urlParams = new URLSearchParams(window.location.search);
  urlParamsHas(urlParams, 'cmdClass', 'page');

  if (objectInfoMenu) {

    if (
      objectInfoMenu.querySelectorAll('li').length < 4
      && !objectInfoMenu.querySelector('#tab_settings')
    ) {
      objectInfoMenu.classList.add('hide');
    }
  }
}


// load html template on startpage
function loadMobileMenuTemplate(){
  fetch('./Customizing/global/skin/bibb2022_7/UI/Layout/tpl.custommobilemenu.html')
    .then(response => response.text())
    .then(text => document.querySelector('.ilc_section_mobileMenu').innerHTML = text)
    .then(el =>
      mobileMenuAnimation()
    );
}

